module.exports = __webpack_public_path__ + "img/info1.b24475ed.png";